export default [
  {
    path: '/user-play-time-record',
    component: () => import('./views/Index'),
    name: 'user-play-time-record',
  },
]
